export default __webpack_public_path__ + "static/media/blog-home-image_mobile.6490c167.png";